<template>
    <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
      <v-card>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span> Make new referral </span>
          <v-btn text icon dark @click="$emit('update:isActive', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
  
        <v-container>
          <custom-form
            :method="method"
            :action="url"
            @submitted="$emit('changed', $event)"
          >
            <v-container>
              <v-row no-gutters>
                <v-col cols="12">
                  <custom-user-search
                    name="referrer_id"
                    label="Select the referrer"
                    item_name="full_name"
                    item_value="id"
                    icon="mdi-account-search"
                  />
                </v-col>
                <v-col>
                    <custom-user-search
                      name="referred_id"
                      label="Select the referred"
                      item_name="full_name"
                      item_value="id"
                      icon="mdi-account-search"
                    />
                </v-col>
                <v-col cols="12">
                  <custom-campaign-search
                    name="campaign_id"
                    label="Select the campaign"
                    item_name="campaign_name"
                    item_value="id"
                    icon="mdi-search"
                  />
                </v-col>
                <v-col cols="12">
                  <custom-button block color="primary"> Confirm </custom-button>
                </v-col>
              </v-row>
            </v-container>
          </custom-form>
        </v-container>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    props: {
      isActive: { required: true, type: Boolean },
      method: { default: "post", type: String },
      paymentType: {
        default: () => {},
        type: Object,
      },
    },
    data() {
      return {
        selected_referrer: null,
        selected_referred: null,
        selected_campaign: null
      };
    },
    computed: {
      url() {
        return "api/v1/initiateReferralFromBackOffice";
      },
    },
  };
  </script>
  